var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" ERROR 404, VOLTE PARA O "),_c('router-link',{attrs:{"tag":"a","to":"/"}},[_vm._v("INICIO CLICANDO AQUI ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }